import { openDB, type DBSchema, type IDBPDatabase } from 'idb';
import type { ChordStats, SessionSummary, TransitionStats } from '@/types/training';

export const DB_NAME = 'chord-trainer';
export const DB_VERSION = 1;

export interface ChordTrainerDB extends DBSchema {
  sessions: {
    key: string;
    value: SessionSummary;
    indexes: { 'by-date': number };
  };
  transitions: {
    key: string;
    value: TransitionStats;
  };
  chordStats: {
    key: string;
    value: ChordStats;
  };
}

let dbPromise: Promise<IDBPDatabase<ChordTrainerDB>> | null = null;

/** Opens (and upgrades) the database. Safe to call repeatedly. */
export function getDb(): Promise<IDBPDatabase<ChordTrainerDB>> {
  if (!dbPromise) {
    dbPromise = openDB<ChordTrainerDB>(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('sessions')) {
          const sessions = db.createObjectStore('sessions', { keyPath: 'id' });
          sessions.createIndex('by-date', 'startedAt');
        }
        if (!db.objectStoreNames.contains('transitions')) {
          db.createObjectStore('transitions', { keyPath: 'key' });
        }
        if (!db.objectStoreNames.contains('chordStats')) {
          db.createObjectStore('chordStats', { keyPath: 'chordId' });
        }
      },
    });
  }
  return dbPromise;
}

/** Test hook — drops the cached connection so a fresh database can be opened. */
export function resetDbForTests(): void {
  dbPromise = null;
}
